/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/montage/montage',['require','backbone','core/base-screen'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  // var $ = require('jquery');
  var Backbone = require('backbone');
  var BaseScreen = require('core/base-screen');

  /*****************************************************************************************************************///}

  var Montage = BaseScreen.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    events: {
      'click .right-arrow:not(.disabled)': 'advanceStep',
      'click .left-arrow:not(.disabled)': 'reverseStep'
    },

    stepIndex: 0,
    nodes: [],

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      BaseScreen.prototype.initialize.apply(this, arguments);

      //console.log('Montage::initialize');

      this.nodes = new Backbone.Collection(this.model.get('nodes'));
    },

    onShow: function()
    {
      this.playMedia();

      this.checkArrows();

      this.showCurrentStep();
    },

    advanceStep: function(e)
    {
      if (this.stepIndex >= this.nodes.length - 1)
        return;

      // increment stepIndex
      this.stepIndex++;

      this.showCurrentStep();
    },

    reverseStep: function(e)
    {
      if (this.stepIndex === 0)
        return;

      // decrement stepIndex
      this.stepIndex--;

      this.showCurrentStep();
    },

    checkArrows: function()
    {
      // hide back arrow if on first step
      this.$el.find('.left-arrow').toggleClass('disabled', this.stepIndex === 0);

      // hide next arrow at end
      this.$el.find('.right-arrow').toggleClass('disabled', this.stepIndex >= this.nodes.length - 1);
    },

    showCurrentStep: function()
    {
      // deactivate
      this.$el.find('.step').removeClass('active');
      this.$el.find('.dot').removeClass('active');

      this.checkArrows();

      // if at end mark page as finished
      if (this.stepIndex >= this.nodes.length - 1)
        this.finish();

      var step = this.nodes.at(this.stepIndex);

      if (step)
      {
        this.$el.find('div[data-index=' + this.stepIndex + ']').addClass('active');
        this.$el.find('.dot[data-index=' + this.stepIndex + ']').addClass('active');
        this.$el.find('.background').addClass('inactive');

        if (step.get('media'))
          this.playMedia({ media: step.get('media') });

        step.set('complete', true);
      }
    }

  /*****************************************************************************************************************///}

  });

  return Montage;

});

